import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes"],
    _excluded2 = ["children", "selectProps"];
import React from 'react';
import { components } from 'react-select';
import classNames from 'classnames/bind';
import { arrayOf, node, oneOfType } from 'prop-types';
import styles from '../Select.css';
import { selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
export var MultiValueContainer = function MultiValueContainer(_ref) {
  var children = _ref.children,
      _ref$selectProps = _ref.selectProps,
      classes = _ref$selectProps.classes,
      rest = _objectWithoutProperties(_ref$selectProps, _excluded),
      props = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/React.createElement(components.MultiValueContainer, _extends({}, props, rest, {
    className: cx('MultiValueContainer', classes.multiValueContainer)
  }), children);
};
MultiValueContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]).isRequired,
  selectProps: selectPropsPropTypes
} : {};